(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-coffin-form]');
    form.querySelector('button[type="submit"]').disabled = !(root.dataset.preview === 'true' || root.dataset.purchasable === 'true');
    const panels = [...root.querySelectorAll('[data-coffin]')];
    const error = root.querySelector('[data-coffin-error]');
    const quantity = form.elements.quantity;
    const money = new Intl.NumberFormat(root.dataset.locale, {style: 'currency', currency: root.dataset.currency});
    const update = () => {
      let ready = 0;
      panels.forEach(panel => {
        if (panel.hasAttribute('data-cocada-panel')) {
          const flavor = panel.querySelector('[data-cocada-flavor]:checked');
          panel.dataset.complete = flavor ? 'true' : 'false';
          panel.querySelector('[data-syrup-property]').value = flavor ? flavor.value : '';
          panel.querySelector('[data-coffin-status]').textContent = flavor ? flavor.closest('label').querySelector('span').textContent.trim() : root.dataset.chooseCocada;
          if (flavor) ready++;
          return;
        }
        const gummies = [...panel.querySelectorAll('[data-gummy]:checked')];
        const chamoy = panel.querySelector('[data-chamoy]:checked');
        const heat = panel.querySelector('[data-heat]:checked');
        const invalidGushers = gummies.some(input => input.value === 'Gushers') && new Set(gummies.filter(input => input.value !== 'Gushers' && !input.hasAttribute('data-mixed')).map(input => input.value)).size < 3;
        panel.dataset.gushersInvalid = String(invalidGushers);
        const gushersError = panel.querySelector('[data-gushers-error]');
        gushersError.textContent = root.dataset.gushersMessage;
        gushersError.hidden = !invalidGushers;
        panel.querySelectorAll('[data-gummy]').forEach(input => {
          if (invalidGushers) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
        });
        const complete = gummies.length > 0 && !invalidGushers && chamoy && heat;
        panel.dataset.complete = complete ? 'true' : 'false';
        panel.querySelector('[data-gummy-property]').value = gummies.map(input => input.value).join(', ');
        panel.querySelector('[data-pouch-property]').value = chamoy && heat ? chamoy.value + ' · ' + heat.value : '';
        panel.querySelector('[data-coffin-status]').textContent = complete ? gummies.map(input => input.closest('label').querySelector('[data-gummy-label]').textContent.trim()).join(', ') + ' · ' + chamoy.value + ' · ' + heat.closest('label').textContent.trim() : root.dataset.choose;
        if (complete) ready++;
      });
      root.querySelector('[data-coffin-progress]').textContent = ready + ' / 2 ' + root.dataset.readyText;
      root.querySelector('[data-coffin-total]').textContent = money.format(Number(root.dataset.price) / 100 * Math.max(1, Number(quantity.value) || 1));
    };
    root.dataset.readyText = root.dataset.ready;
    form.addEventListener('change', event => {
      if (event.target.matches('[data-gummy]') && event.target.checked) {
        const panel = event.target.closest('[data-coffin]');
        if (event.target.hasAttribute('data-mixed')) panel.querySelectorAll('[data-gummy]:not([data-mixed])').forEach(input => input.checked = false);
        else panel.querySelector('[data-mixed]').checked = false;
      }
      error.hidden = true;
      update();
    });
    form.addEventListener('input', update);
    form.addEventListener('invalid', event => {
      const panel = event.target.closest('[data-coffin]');
      if (panel) panel.open = true;
    }, true);
    form.addEventListener('submit', event => {
      update();
      const incomplete = panels.find(panel => panel.dataset.complete !== 'true');
      if (incomplete) {
        event.preventDefault();
        incomplete.open = true;
        error.textContent = incomplete.dataset.gushersInvalid === 'true' ? root.dataset.gushersMessage : root.dataset.missing;
        error.hidden = false;
        incomplete.querySelector('[data-gummy], [data-cocada-flavor]').focus();
        error.scrollIntoView({block: 'center', behavior: 'instant'});
        return;
      }
      if (root.dataset.preview === 'true') {
        event.preventDefault();
        const summary = root.querySelector('[data-preview-summary]');
        summary.textContent = root.dataset.previewDone + '\n\n' + panels.map(panel => panel.querySelector('summary strong').textContent.trim() + '\n' + panel.querySelector('[data-coffin-status]').textContent.trim()).join('\n\n');
        summary.hidden = false;
        summary.scrollIntoView({block: 'center', behavior: 'instant'});
      }
    });
    update();
  };
  const start = () => document.querySelectorAll('[data-halloween-mixed]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();

